export default function (event: TouchEvent | Touch): { x: number; y: number } {
  const rect = (event.target as HTMLElement).getBoundingClientRect()
  let pageX = 0
  let pageY = 0

  const touches = (event as TouchEvent).touches
  if (touches && touches.length > 0) {
    const touch = touches[0]
    pageX = touch.pageX
    pageY = touch.pageY
  } else {
    pageX = (event as Touch).pageX
    pageY = (event as Touch).pageY
  }

  const x = Math.abs(Math.round(pageX - rect.left - window.pageXOffset))
  const y = Math.abs(Math.round(pageY - rect.top - window.pageYOffset))

  return { x: x, y: y }
}
